import { ChevronDown, ChevronUp } from 'lucide-react';
import './Dropdown.css';

const Dropdown = ({ title, content, isOpen, onToggle }) => {
  return (
    <div className="dropdown">
      <button 
        className={`dropdown-header ${isOpen ? 'active' : ''}`}
        onClick={onToggle}
      >
        <h3>{title}</h3>
        {isOpen ? <ChevronUp size={24} className='icon'/> : <ChevronDown size={24} className='icon'/>}
      </button>
      
      <div className={`dropdown-content ${isOpen ? 'open' : ''}`}>
        <p>{content}</p>
      </div>
    </div>
  );
};

export default Dropdown;